module.exports = __webpack_public_path__ + "img/img_slogan_draw.7ce49946.png";